import React from 'react';
import { getResources, MenuItemLink, Responsive } from 'react-admin';
import { connect } from 'react-redux';
import { withStyles, Collapse, List, ListSubheader } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
// import ListItemIcon from '@material-ui/core/ListItemIcon';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import DefaultIcon from '@material-ui/icons/ViewList';
import { useTokenOps } from "./TokenContext";
import { carbonRequest } from "../resources/corporateCarbon/api";
const styles = {
  root: {}, // Style applied to the MenuItem from material-ui
  active: { fontWeight: 'bold' }, // Style applied when the menu item is the active one
  icon: {}, // Style applied to the icon
  companyName: {
    fontWeight: 600,
    fontSize: '20px',
    color: 'black',
  },
};

const groupBy = (xs, group) => {
  return xs.reduce((rv, x) => {
    (rv[group(x)] = rv[group(x)] || []).push(x);
    return rv;
  }, {});
};

const menuGroups = [
  'Commercial',
  'Bcome',
  'Accounts',
  'Projects',
  'Articles',
  'Materials',
  'Suppliers',
  'Packaging',
  'Carbon Accounting',
  'Upload logs'
];

const formatLabel = (label) => (
  <span style={{
    display: 'inline-block',
    maxWidth: '160px',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
    wordBreak: 'break-word',
  }}>
    {label}
  </span>
);

export const selectVisibleMenuResources = resources => (
  resources.filter(resource => resource.options?.hideInMenu !== true)
);

export const safeIconTitle = title => (
  typeof title === 'string' ? title : undefined
);

const commercialOperationsPaths = new Set([
  '/commercial-imports',
  '/commercial-entry',
  '/commercial-automation',
  '/commercial-email-templates',
  '/commercial-workflow-history',
  '/commercial-audit',
]);

export const isCommercialOperationsPath = pathname => commercialOperationsPaths.has(pathname);

const safeIconComponents = new Map();
const safeResourceIcon = Icon => {
  if (safeIconComponents.has(Icon)) return safeIconComponents.get(Icon);
  const SafeIcon = ({ titleAccess, ...props }) => (
    <Icon {...props} titleAccess={safeIconTitle(titleAccess)} />
  );
  safeIconComponents.set(Icon, SafeIcon);
  return SafeIcon;
};


class NestedList extends React.Component {
  state = { open: false };


  handleClick = open => () => {
    this.setState({ open });
  };

  render() {
    const { title } = this.props;

    return (
      <div style={this.props.nested ? this.nestedStyle : undefined}>
        <List>
          <ListItem button onClick={this.handleClick(!this.state.open)}>
            {/* {this.props.icon && <ListItemIcon>{this.props.icon}</ListItemIcon>} */}
            <ListItemText primary={title} />
            {this.state.open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={this.state.open} timeout="auto" unmountOnExit>
            <List
              component="div"
              disablePadding
              style={this.props.nested ? this.nestedStyle : undefined}
            >
              {this.props.children}
            </List>
          </Collapse>
        </List>
      </div>
    );
  }
}

export const CustomMenu = ({ resources, onMenuClick, logout, dense, classes }) => {
  const tokenOps = useTokenOps();
  const accountAccessToken = tokenOps.account?.accessToken;
  const [carbonEnabled, setCarbonEnabled] = React.useState(false);

  React.useEffect(() => {
    let active = true;
    setCarbonEnabled(false);

    if (accountAccessToken) {
      carbonRequest(accountAccessToken, "corporate-carbon/access")
        .then(({ enabled }) => {
          if (active) setCarbonEnabled(enabled === true);
        })
        .catch(() => {
          if (active) setCarbonEnabled(false);
        });
    }

    return () => {
      active = false;
    };
  }, [accountAccessToken]);

  const authorizedResources = carbonEnabled
    ? resources
    : resources.filter(
      resource =>
        resource.options.menuGroup !== 'Carbon Accounting' &&
        resource.name !== 'accountCarbonUploads'
    );
  const visibleResources = selectVisibleMenuResources(authorizedResources).map(resource => ({
    ...resource,
    icon: safeResourceIcon(resource.icon || DefaultIcon),
  }));
  const groupResources = groupBy(visibleResources, resource => resource.options.menuGroup);
  const [processesOpen, setProcessesOpen] = React.useState(false);
  const [processOriginsOpen, setProcessOriginsOpen] = React.useState(false);
  const [processByAccountOpen, setProcessByAccountOpen] = React.useState(false);
  const [materialProcessesOpen, setMaterialProcessesOpen] = React.useState(false);
  const [articleProcessOpen, setArticleProcessOpen] = React.useState(false);
  const [articleImpactOpen, setArticleImpactOpen] = React.useState(false);
  const [carbonOpen, setCarbonOpen] = React.useState(false);
  const [businessRulesOpen, setBusinessRulesOpen] = React.useState(false);

  // Data Seamless admin screens grouped under a "Business rules" submenu inside Bcome.
  const businessRulesResources = ['businessRulesCatalog', 'processApplicability', 'weightShares', 'fieldDefinitionsCoverage'];
  const processResources = ['extraction', 'processing', 'finishing', 'manufacturing', 'packaging', 'transport', 'trimming'];
  const processOriginResources = ['processOrigin/extraction', 'processOrigin/processing', 'processOrigin/finishing', 'processOrigin/manufacturing', 'processOrigin/packaging', 'processOrigin/transport', 'processOrigin/trimming'];
  const processByAccountResources = ['processByAccount/extraction', 'processByAccount/finishing', 'processByAccount/manufacturing', 'processByAccount/packaging', 'processByAccount/processing', 'processByAccount/transport', 'processByAccount/trimming'];
  const materialProcessResources = ['materialExtraction', 'materialProcessing', 'materialFinishing'];
  const materialImpactResources = ['materialImpact'];
  // Este recurso será reemplazado por el desplegable
  const articleProcessResource = 'articleProcess';
  // Recursos que pertenecen al submenú de Article Process
  const articleProcessSubResources = visibleResources.filter(resource => resource.options.menuGroup === 'Article Process Sub');
  // Recursos que pertenecen al submenú de Article Impacts
  const articleImpactSubResources = visibleResources.filter(
    resource =>
      resource.options.menuGroup === 'Article Impact Sub' &&
      resource.options.hiddenFromMenu !== true
  );
  // Nombres de los recursos específicos para Article Process

  const menuItems = menuGroups.map(menuGroup => {
    if (menuGroup === 'Carbon Accounting' && !groupResources[menuGroup]) {
      return null;
    }
    if (menuGroup === 'Bcome') {
      // Ordenar recursos de Bcome para que databaseUpload aparezca primero
      const bcomeResources = groupResources[menuGroup]
        ? groupResources[menuGroup]
          .filter(resource => !processResources.includes(resource.name) && !processOriginResources.includes(resource.name) && !processByAccountResources.includes(resource.name) && !materialProcessResources.includes(resource.name) && !businessRulesResources.includes(resource.name))
          .sort((a, b) => {
            // database-upload siempre primero
            if (a.name === 'database-upload') return -1;
            if (b.name === 'database-upload') return 1;
            // Mantener orden original para los demás
            return 0;
          })
        : [];
      const databaseUploadResources = bcomeResources.filter(
        resource => resource.name === 'database-upload'
      );
      const otherBcomeResources = bcomeResources.filter(
        resource => resource.name !== 'database-upload'
      );
      const carbonResources = groupResources['Bcome Carbon'] || [];

      return (
        <React.Fragment key={menuGroup}>
          <Divider />
          <NestedList title={menuGroup}>
            {databaseUploadResources.map(resource => (
              <MenuItemLink
                key={resource.name}
                to={`/${resource.name}`}
                primaryText={formatLabel(resource.options.label)}
                leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                onClick={onMenuClick}
                dense={dense}
                style={{ display: 'flex', alignItems: 'start' }}
              />
            ))}

            {carbonResources.length > 0 && (
              <>
                <div style={{ position: 'relative' }}>
                  <ListItem
                    button
                    aria-expanded={carbonOpen}
                    onClick={() => setCarbonOpen(!carbonOpen)}
                    style={{ color: '#0000008a', padding: '0 16px' }}
                  >
                    <DefaultIcon style={{ marginRight: '16px' }} />
                    <ListItemText primary="Carbon" />
                    {carbonOpen ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                </div>
                <Collapse in={carbonOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                    {carbonResources.map(resource => (
                      <MenuItemLink
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={formatLabel(resource.options.label)}
                        leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                        onClick={onMenuClick}
                        dense={dense}
                      />
                    ))}
                  </List>
                </Collapse>
              </>
            )}

            {otherBcomeResources.map(resource => (
              <MenuItemLink
                key={resource.name}
                to={`/${resource.name}`}
                primaryText={formatLabel(resource.options.label)}
                leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                onClick={onMenuClick}
                dense={dense}
                style={{ display: 'flex', alignItems: 'start' }}
              />
            ))}

            <div style={{ position: 'relative' }}>
              <ListItem
                button
                onClick={() => setBusinessRulesOpen(!businessRulesOpen)}
                style={{
                  color: '#0000008a',
                  padding: '0 16px',
                }}
              >
                <DefaultIcon style={{ marginRight: '16px' }} />
                <ListItemText primary="Business rules" />
                {businessRulesOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </div>
            <Collapse in={businessRulesOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                {businessRulesResources
                  .map(name => resources.find(resource => resource.name === name))
                  .filter(Boolean)
                  .map(resource => (
                    <MenuItemLink
                      key={resource.name}
                      to={`/${resource.name}`}
                      primaryText={formatLabel(resource.options.label)}
                      leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                      onClick={onMenuClick}
                      dense={dense}
                    />
                  ))}
              </List>
            </Collapse>

            <div style={{ position: 'relative' }}>
              <ListItem
                button
                onClick={() => setProcessesOpen(!processesOpen)}
                style={{
                  color: '#0000008a',
                  padding: '0 16px',
                }}
              >
                <DefaultIcon style={{ marginRight: '16px' }} />
                <ListItemText primary="Processes" />
                {processesOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </div>
            <Collapse in={processesOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                {groupResources[menuGroup] &&
                  groupResources[menuGroup]
                    .filter(resource => processResources.includes(resource.name))
                    .map(resource => (
                      <MenuItemLink
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={formatLabel(resource.options.label)}
                        leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                        onClick={onMenuClick}
                        dense={dense}
                      />
                    ))}
              </List>
            </Collapse>

            <div style={{ position: 'relative' }}>
              <ListItem
                button
                onClick={() => setProcessOriginsOpen(!processOriginsOpen)}
                style={{
                  color: '#0000008a',
                  padding: '0 16px',
                }}
              >
                <DefaultIcon style={{ marginRight: '16px' }} />
                <ListItemText primary="Process by origin" />
                {processOriginsOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </div>
            <Collapse in={processOriginsOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                {visibleResources
                  .filter(resource => processOriginResources.includes(resource.name))
                  .map(resource => (
                    <MenuItemLink
                      key={resource.name}
                      to={`/${resource.name}`}
                      primaryText={formatLabel(resource.options.label)}
                      leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                      onClick={onMenuClick}
                      dense={dense}
                    />
                  ))}
              </List>
            </Collapse>

            <div style={{ position: 'relative' }}>
              <ListItem
                button
                onClick={() => setProcessByAccountOpen(!processByAccountOpen)}
                style={{
                  color: '#0000008a',
                  padding: '0 16px',
                }}
              >
                <DefaultIcon style={{ marginRight: '16px' }} />
                <ListItemText primary="Process by account" />
                {processByAccountOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </div>
            <Collapse in={processByAccountOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                {visibleResources
                  .filter(resource => processByAccountResources.includes(resource.name))
                  .map(resource => (
                    <MenuItemLink
                      key={resource.name}
                      to={`/${resource.name}`}
                      primaryText={formatLabel(resource.options.label)}
                      leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                      onClick={onMenuClick}
                      dense={dense}
                    />
                  ))}
              </List>
            </Collapse>
          </NestedList>
        </React.Fragment>
      );
    } else if (menuGroup === 'Materials') {
      return (
        <React.Fragment key={menuGroup}>
          <Divider />
          <NestedList title={menuGroup}>
            {groupResources[menuGroup] &&
              groupResources[menuGroup]
                .filter(resource => !materialProcessResources.includes(resource.name) && !materialImpactResources.includes(resource.name))
                .map(resource => (
                  <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={formatLabel(resource.options.label)}


                    leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                    onClick={onMenuClick}
                    dense={dense}
                  />
                ))}

            <div style={{ position: 'relative' }}>
              <ListItem
                button
                onClick={() => setMaterialProcessesOpen(!materialProcessesOpen)}
                style={{
                  color: '#0000008a',
                  padding: '0 16px',
                }}
              >
                <DefaultIcon style={{ marginRight: '16px' }} />
                <ListItemText primary="Material processes" />
                {materialProcessesOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </div>
            <Collapse in={materialProcessesOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                {visibleResources
                  .filter(resource => materialProcessResources.includes(resource.name))
                  .map(resource => (
                    <MenuItemLink
                      key={resource.name}
                      to={`/${resource.name}`}
                      primaryText={formatLabel(resource.options.label)}
                      leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                      onClick={onMenuClick}
                      dense={dense}
                    />
                  ))}
              </List>
            </Collapse>

            {/* Material Impacts - appears after Material processes */}
            {visibleResources
              .filter(resource => materialImpactResources.includes(resource.name))
              .map(resource => (
                <MenuItemLink
                  key={resource.name}
                  to={`/${resource.name}`}
                  primaryText={formatLabel(resource.options.label)}
                  leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                  onClick={onMenuClick}
                  dense={dense}
                />
              ))}
          </NestedList>
        </React.Fragment>
      );

    } else if (menuGroup === 'Articles') {
      return (
        <React.Fragment key={menuGroup}>
          <Divider />
          <NestedList title={menuGroup}>
            {groupResources[menuGroup] &&
              groupResources[menuGroup]
                .filter(resource => resource.name !== articleProcessResource)
                .map(resource => (
                  <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={formatLabel(resource.options.label)}
                    leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                    onClick={onMenuClick}
                    dense={dense}
                  />
                ))}

            <div style={{ position: 'relative' }}>
              <ListItem
                button
                onClick={() => setArticleProcessOpen(!articleProcessOpen)}
                style={{
                  color: '#0000008a',
                  padding: '0 16px',
                }}
              >
                <DefaultIcon style={{ marginRight: '16px' }} />
                <ListItemText primary="Article processes" />
                {articleProcessOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </div>
            <Collapse in={articleProcessOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                {articleProcessSubResources.map(resource => (
                  <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name.replace('/', '%2F')}`}
                    primaryText={formatLabel(resource.options.label)}
                    leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                    onClick={onMenuClick}
                    dense={dense}
                  />
                ))}
              </List>
            </Collapse>

            <div style={{ position: 'relative' }}>
              <ListItem
                button
                onClick={() => setArticleImpactOpen(!articleImpactOpen)}
                style={{ color: '#0000008a', padding: '0 16px' }}
              >
                <DefaultIcon style={{ marginRight: '16px' }} />
                <ListItemText primary="Article Impacts" />
                {articleImpactOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            </div>
            <Collapse in={articleImpactOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding style={{ paddingLeft: '32px' }}>
                {articleImpactSubResources.map(resource => (
                  <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={formatLabel(resource.options.label)}
                    leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                    onClick={onMenuClick}
                    dense={dense}
                  />
                ))}
              </List>
            </Collapse>
          </NestedList>
        </React.Fragment>
      );
    } else if (menuGroup === 'Process Origin') {
      return (
        <React.Fragment key={menuGroup}>
          <Divider />
          <NestedList title={menuGroup}>
            {visibleResources
              .filter(resource => processOriginResources.includes(resource.name))
              .map(resource => (
                <MenuItemLink
                  key={resource.name}
                  to={`/${resource.name}`}
                  primaryText={formatLabel(resource.options.label)}
                  leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                  onClick={onMenuClick}
                  dense={dense}
                />
              ))}
          </NestedList>
        </React.Fragment>
      );
    } else if (menuGroup === 'Processes') {
      return (
        <React.Fragment key={menuGroup}>
          <Divider />
          <NestedList title={menuGroup}>
            {groupResources[menuGroup] &&
              groupResources[menuGroup]
                .filter(resource => processResources.includes(resource.name))
                .map(resource => (
                  <MenuItemLink
                    key={resource.name}
                    to={`/${resource.name}`}
                    primaryText={formatLabel(resource.options.label)}
                    leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                    onClick={onMenuClick}
                    dense={dense}
                  />
                ))}
          </NestedList>
        </React.Fragment>
      );
    } else if (menuGroup === 'Carbon Accounting') {
      const groups = [
        ['Setup', ['Corporate profile', 'Sites']],
        ['Annual inventory', ['Inventories', 'Boundaries', 'Activities', 'Evidence', 'Finalization']],
        ['Calculation & reporting', ['Calculations', 'Results', 'Exports']],
        ['Audit', ['Audit history']],
      ];
      return <React.Fragment key={menuGroup}><Divider /><NestedList title={menuGroup}>
        {groups.map(([heading, labels]) => <React.Fragment key={heading}>
          <ListSubheader disableSticky>{heading}</ListSubheader>
          {labels.map(label => (groupResources[menuGroup] || []).find(resource => resource.options.label === label)).filter(Boolean).map(resource => (
            <MenuItemLink key={resource.name} to={`/${resource.name}`} primaryText={formatLabel(resource.options.label)} leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />} onClick={onMenuClick} dense={dense} />
          ))}
        </React.Fragment>)}
      </NestedList></React.Fragment>;
    } else {
      const resourcesForGroup = groupResources[menuGroup] || [];
      const uploadLogOrder = ['uploadHistory', 'calculationLog'];
      const orderedResources = menuGroup === 'Upload logs'
        ? [...resourcesForGroup].sort(
          (a, b) => uploadLogOrder.indexOf(a.name) - uploadLogOrder.indexOf(b.name)
        )
        : resourcesForGroup;

      return (
        <React.Fragment key={menuGroup}>
          <Divider />
          <NestedList title={menuGroup}>
            {orderedResources.map(resource => (
                <MenuItemLink
                  key={resource.name}
                  to={`/${resource.name}`}
                  primaryText={formatLabel(resource.options.label)}

                  leftIcon={resource.icon ? <resource.icon /> : <DefaultIcon />}
                  onClick={onMenuClick}
                  dense={dense}
                  isActive={resource.name === 'commercial-imports'
                    ? ((match, location) => isCommercialOperationsPath(location.pathname))
                    : undefined}
                />
              ))}
          </NestedList>
        </React.Fragment>
      );
    }
  });

  return (
    <div>
      {tokenOps.account && (<MenuItemLink
        primaryText={<span className={classes.companyName}>{tokenOps.account.data?.accountName}</span>}
        to={`/accounts/${tokenOps.account.data?.accountId}/show`}
      />)}
      {menuItems}
      <Responsive
        small={logout}
        medium={null}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  resources: getResources(state),
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(CustomMenu)));
